/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import {Box, ThemeProvider} from '@mui/material'
import {graphql, useStaticQuery} from 'gatsby'
import * as React from 'react'
import {ReactNode} from 'react'
import Footer, {FooterProps} from './Footer'

import rootTheme from './rootTheme'

export type LayoutProps = {
  children: ReactNode
  footerProps?: FooterProps
}

const Layout = ({children, footerProps={}}: LayoutProps) => {
  useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ThemeProvider theme={rootTheme}>
      <Box
        sx={{
          margin: '0 auto',
          maxWidth: 320,
          paddingY: 2,
          color: 'common.black',
        }}
      >
        <main>{children}</main>
        <Footer {...footerProps}/>
      </Box>
    </ThemeProvider>
  )
}

export default Layout
